export enum UserStatus {
  Active = "A",

  Inactive = "I",

  WaitingForEmailConfirmation = "W",
}

export enum UserProfile {
  ADMINISTRATOR = 1,
  MANAGER = 2,
  ATTENDANT = 3,
  REPRESENTATIVE = 4,
  OPERATIONS = 5,
}
